export default __webpack_public_path__ + "static/media/navbar-regular-dark.55b14ebc.svg";